export function toUnderscoreKey(string) {
  return string.replace(/([A-Z])/g, (match) => `_${match.toLowerCase()}`);
}

export function transformKeysToUnderscore(object, keyNameOverrides = {}) {
  return Object.keys(object).reduce((convertedKeys, key) => {
    let underscoredKey = toUnderscoreKey(key);
    if (Object.prototype.hasOwnProperty.call(keyNameOverrides, underscoredKey)) {
      underscoredKey = keyNameOverrides[underscoredKey];
    }
    convertedKeys[underscoredKey] = object[key];
    return convertedKeys;
  }, {});
}
